import React, { useEffect, useState } from 'react';
import { Button, Select } from 'antd';
import { getRandomKey } from '@approvals/services/approvals-service';
import { Icon, Form } from '@common/components';
type Props = {
  approvers: { value: string; label: string }[];
  addApprover: (approverId: string) => void;
  forceSelect?: boolean;
  disabled?: boolean;
};

export const ApprovalsEditDrawerApproverSelect = ({
  approvers,
  addApprover,
  forceSelect,
  disabled,
}: Props) => {
  const [addingApprover, setAddingApprover] = useState(false);
  const [showCancel, setShowCancel] = useState(true);

  useEffect(() => {
    setShowCancel(true);
    if (disabled) {
      setShowCancel(false);
      setAddingApprover(false);
    } else if (forceSelect) {
      setShowCancel(false);
      setAddingApprover(true);
    }
  }, [forceSelect, disabled]);

  if (!addingApprover) {
    return (
      <Button
        disabled={disabled}
        icon={<Icon icon="userPlus" kind="light" size="sm" />}
        onClick={() => setAddingApprover(true)}
      >
        &nbsp;Add Approver
      </Button>
    );
  }

  return (
    <>
      <Form.Item
        className="approvals-page-drawer-approver__select-wrapper"
        name={`approver-${getRandomKey()}`}
        rules={[
          {
            required: true,
            message: 'Please select an approver',
          },
        ]}
      >
        <Select
          id="approval-antd-select"
          placeholder="Select approver"
          showSearch
          onChange={(approverId) => {
            addApprover(approverId);
            setAddingApprover(false);
          }}
          filterOption={(input, option) => {
            // Filtering manually since our `value` is an UUID, and we want to filter by `label`
            return (
              option?.label.toLowerCase().includes(input.toLowerCase()) || false
            );
          }}
          options={approvers}
          style={{
            minWidth: '200px',
          }}
        />
      </Form.Item>
      {showCancel && (
        <Button
          className="approvals-page-drawer-approver__cancel-button"
          onClick={() => setAddingApprover(false)}
        >
          Cancel
        </Button>
      )}
      <style jsx>{`
        :global(.approvals-page-drawer-approver__select-wrapper) {
          display: inline-block;
          width: auto;
          margin: 0;
        }
        :global(.approvals-page-drawer-approver__cancel-button) {
          margin-left: 16px;
        }
      `}</style>
    </>
  );
};
